import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersEmployeesEmployeeCompetencyReviewsIndexResponseType } from "~/domains";

type RequestDataType = {
  employeeId: string;
  page?: number;
};

const request = async ({
  employeeId,
  page = 1,
}: RequestDataType): Promise<ApiManagersEmployeesEmployeeCompetencyReviewsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersEmployeesEmployeeCompetencyReviewsIndexResponseType>(
      `/api/managers/employees/${employeeId}/employee_competency_reviews`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  employeeId: string;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersEmployeesEmployeeCompetencyReviewsIndex = ({
  employeeId,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApiManagersEmployeesEmployeeCompetencyReviewsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApiManagersEmployeesEmployeeCompetencyReviewsIndex", employeeId],
    ({ pageParam }) => {
      return request({ employeeId, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
